// UploadsBlock.tsx
import React, { useRef, useEffect, useState } from 'react';
import s from './PromtBlocks.module.css';
import IconAdd from '../../../../shared/ui/icons/IconAdd';
import { useSelector } from 'react-redux';
import { selectUploadImages, selectDraggedImage } from '../../../../store/selectors/imageSelectors';

import { useAppDispatch } from '../../../../store/store';
import { uploadImage } from '../../../../shared/api/imageProjectApi';
import { setDraggedImage } from '../../../../store/slices/imageSlice';
import { ImageAttributes } from '../../../../shared/types/imagesType';
import { toast } from 'react-toastify';
const UploadsBlock: React.FC = () => {
    const fileInputRef = useRef<HTMLInputElement>(null);
    const dispatch = useAppDispatch();
    const uploadImages = useSelector(selectUploadImages);
    const draggedImage = useSelector(selectDraggedImage);
    const [isLoading, setIsLoading] = useState(false);
    const [draggingImageId, setDraggingImageId] = useState<string | null>(null);

    const handleAddClick = () => {
        fileInputRef.current?.click();
    };

    const handleFilesChange: React.ChangeEventHandler<HTMLInputElement> = async (e) => {
        const files = e.target.files;
        console.log('handleFilesChange', files);
        if (!files) return;

        try {
            setIsLoading(true);
            const file = files[0];
            await dispatch(uploadImage({ file })).unwrap();
            setIsLoading(false);
            toast.success('Image uploaded successfully');
        } catch (error: any) {
            console.error('Failed to upload image:', error);
            toast.error(error?.message || 'Failed to upload image');
            setIsLoading(false);
        }
        e.target.value = '';
    };

    const handleDragStart = (e: React.DragEvent<HTMLDivElement>, image: ImageAttributes) => {
        dispatch(setDraggedImage(image));
        setDraggingImageId(image.id);
        e.dataTransfer.effectAllowed = 'copy';
        e.dataTransfer.setData('text/plain', image.id);

        const dragImage = e.currentTarget.cloneNode(true) as HTMLElement;
        dragImage.style.opacity = '1';
        dragImage.style.border = '2px solid #ffdd35';
        dragImage.style.borderRadius = '0';
        dragImage.style.boxShadow = 'none';
        dragImage.style.position = 'absolute';
        dragImage.style.top = '-1000px';
        dragImage.style.left = '-1000px';
        dragImage.style.pointerEvents = 'none';

        document.body.appendChild(dragImage);

        e.dataTransfer.setDragImage(dragImage, 45, 45);
        setTimeout(() => {
            document.body.removeChild(dragImage);
        }, 0);

        console.log('draggedImage', image);
    };

    const handleDragEnd = (e: React.DragEvent<HTMLDivElement>) => {
        dispatch(setDraggedImage(null));
        setDraggingImageId(null);
    };

    const handleDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    };

    const handleDragEnter = (e: React.DragEvent<HTMLDivElement>, imageId: string) => {
        e.preventDefault();
        if (draggedImage && draggedImage.id !== imageId) {
        }
    };

    const handleDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    const handleContainerDragOver = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    };

    const handleContainerDragLeave = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    const handleContainerDrop = (e: React.DragEvent<HTMLDivElement>) => {
        e.preventDefault();
    };

    return (
        <div className={s.container}>
            <p className={s.title}>Select an image or upload your own</p>
            <div
                className={`${s.uploads_container}`}
                onDragOver={handleContainerDragOver}
                onDragLeave={handleContainerDragLeave}
                onDrop={handleContainerDrop}
            >
                <input
                    type="file"
                    accept="image/*"
                    multiple
                    ref={fileInputRef}
                    onChange={handleFilesChange}
                    className={s.hidden_input}
                />

                <div
                    className={s.upload_container}
                    onClick={!isLoading ? handleAddClick : undefined}
                >
                    {isLoading ? <div className={s.spinner} /> : <IconAdd width={18} />}
                </div>

                {uploadImages.map((img) => (
                    <div
                        key={img.id}
                        className={`${s.upload_container} ${
                            draggingImageId === img.id ? s.dragging : ''
                        } `}
                        draggable
                        onDragStart={(e) => handleDragStart(e, img)}
                        onDragEnd={handleDragEnd}
                        onDragOver={handleDragOver}
                        onDragEnter={(e) => handleDragEnter(e, img.id)}
                        onDragLeave={handleDragLeave}
                    >
                        <img src={img.url} className={s.image} alt={img.name} />
                        <div className={s.drag_indicator}>⋮⋮</div>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default UploadsBlock;
